<template>
  <router-view v-if="routedVideo" />
  <transition-fade v-else :duration="500" appear>
    <media-archive
      v-if="activeSchoolLevel?.archivedVideos.length"
      :items="activeSchoolLevel?.archivedVideos"
      v-slot="{ items }"
    >
      <transition-group
        name="media"
        tag="div"
        class="contents media"
        @before-leave="mediaItemBeforeLeave"
      >
        <div v-for="item in items" :key="item.slug">
          <video-preview
            :key="item.slug"
            :video="item"
            :to="{
              name: 'FilmArchiveVideoPlayer',
              params: {
                volumeSlug: activeVolume.slug,
                schoolLevelSlug: activeSchoolLevel.slug,
                videoSlug: item.slug,
              },
            }"
            small
            class="video-list__video-item--search-result"
          />
        </div>
      </transition-group>
    </media-archive>
    <div v-else class="flex h-full justify-center items-center">
      <box-generic header="Geen materiaal">
        <p class="mt-3 leading-relaxed">Er zijn geen filmpjes beschikbaar.</p>
      </box-generic>
    </div>
  </transition-fade>
</template>

<script>
import { mapGetters } from "vuex";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import MediaArchive from "../../../../components/content/archive/MediaArchive.vue";
import VideoPreview from "../../../../components/content/media/VideoPreview.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";

export default {
  name: "FilmArchive",
  components: {
    BoxGeneric,
    MediaArchive,
    TransitionFade,
    VideoPreview,
  },
  computed: {
    ...mapGetters(["activeSchoolLevel", "activeVolume", "routedVideo"]),
  },
  methods: {
    // Fix for list transitions in a flex layout.
    // Need to memorize the position on leave,
    // otherwise items fly enthusiastically into the corner.
    mediaItemBeforeLeave(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.left = `${el.offsetLeft}px`;
      // eslint-disable-next-line no-param-reassign
      el.style.top = `${el.offsetTop}px`;
    },
  },
};
</script>

<style scoped lang="css">
/* Search results (right column) */
::v-deep(#search-results) .scroll-container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

::v-deep(.video-list__video-item--search-result) {
  max-height: calc(
    8.9vw + 36px
  ); /* Aspect ratio to max-width + video title height (36px). */

  &,
  & ::v-deep(img) {
    max-width: 15vw;
  }
}

@media (max-width: 1510px) {
  ::v-deep(.video-list__video-item--search-result) {
    max-height: calc(
      8.6vw + 36px
    ); /* Aspect ratio to max-width + video title height (36px). */

    &,
    & ::v-deep(img) {
      max-width: 13vw;
    }
  }
}

/* Transitions */

.media > * {
  transition: all 300ms ease-out;
}

.media > .media-enter-from,
.media > .media-leave-to {
  opacity: 0;
}

.media > .media-leave-active {
  position: absolute;
}
</style>
